<template>
  <div class="home">
    <Header />
    <div class="middle">
      <SidebarLeft />
      <MainContent />
    </div>
    <Footer />
  </div>

  <!-- <div
    style="display: flex; margin: 0 auto; width: 1000px; background-color: red"
  >
    aaa
  </div> -->
</template>

<script>
// import HeaderTop from '@/components/Header/HeaderTop.vue';
// import HeaderBanner from '@/components/Header/HeaderBanner.vue';
// import HeaderTabs from '@/components/Header/HeaderTabs.vue';
// import SidebarRight from '@/components/SidebarRight.vue';

import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer.vue";
import SidebarLeft from "@/components/SidebarLeft/SidebarLeft.vue";
import MainContent from "@/components/MainContent.vue";

export default {
  name: "Home",
  components: {
    // HeaderTop,
    // HeaderBanner,
    // HeaderTabs,
    Header,
    Footer,
    SidebarLeft,
    // SidebarRight,
    MainContent,
  },
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 1200px;
  margin: 0 auto;
}

.middle {
  display: flex;
  flex: 1;
}
</style>
